import api from './api';

export function salvarEstagioClinico(idTratamento, body) {
  return api.post(`/tratamentos/${idTratamento}/estagio`, body);
}

export function fetchEstagoClinico(idTratamento) {
  return api.get(`/tratamentos/${idTratamento}/estagio`);
}
